import React, { useState } from "react";
import "./shippingAddressHeader.scss";
import BtnStandardIconText from "../../../ds/BtnStandardIconText/BtnStandardIconText";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../../pages/Landings/common/returnText";
import { ReactComponent as USAIcon } from "../../../icons/country/usa.svg";
import { ReactComponent as ChinaIcon } from "../../../icons/country/china.svg";

const ShippingAddressHeader = ({ country, setCountry }) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  return (
    <div className="shipping-address-header">
      <div className="title">
        <div className="main">
          {Returntext(contentManagementData, "ShippingAddressTitle", lang)}
        </div>
        <div className="sub">
          {Returntext(contentManagementData, "ShippingAddressSub", lang)}
        </div>
      </div>

      <div className="countries">
        <BtnStandardIconText
          mode={country === "USA" ? "active" : ""}
          txt={Returntext(contentManagementData, "usa", lang)}
          disabled={false}
          size={"standard"}
          icon={true}
          svg={<USAIcon />}
          iconPosition={"left"}
          mainColor={"grayBorder"}
          onClick={() => setCountry("USA")}
        />

        <BtnStandardIconText
          mode={country === "China Cargo" ? "active" : ""}
          txt={Returntext(contentManagementData, "chinaCargo", lang)}
          disabled={false}
          size={"standard"}
          icon={true}
          svg={<ChinaIcon />}
          iconPosition={"left"}
          mainColor={"grayBorder"}
          onClick={() => setCountry("China Cargo")}
        />

        <BtnStandardIconText
          mode={country === "China AIR" ? "active" : ""}
          txt={Returntext(contentManagementData, "chinaAir", lang)}
          disabled={false}
          size={"standard"}
          icon={true}
          svg={<ChinaIcon />}
          iconPosition={"left"}
          mainColor={"grayBorder"}
          onClick={() => setCountry("China AIR")}
        />
      </div>
    </div>
  );
};

export default ShippingAddressHeader;
